import React from 'react';
import ShalgahBalance from './shalgahBalance';

const PageList = () => <ShalgahBalance />;

export default PageList;
